/*
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
export var acceptLanguage0 = {
    parameterPath: "acceptLanguage",
    mapper: {
        required: true,
        serializedName: "Accept-Language",
        type: {
            name: "String"
        }
    }
};
export var acceptLanguage1 = {
    parameterPath: [
        "options",
        "acceptLanguage"
    ],
    mapper: {
        serializedName: "Accept-Language",
        type: {
            name: "String"
        }
    }
};
export var accountId = {
    parameterPath: "accountId",
    mapper: {
        required: true,
        serializedName: "accountId",
        type: {
            name: "String"
        }
    }
};
export var addressId0 = {
    parameterPath: "addressId",
    mapper: {
        required: true,
        serializedName: "addressId",
        type: {
            name: "String"
        }
    }
};
export var addressId1 = {
    parameterPath: "addressId",
    mapper: {
        required: true,
        serializedName: "addressId",
        type: {
            name: "Number"
        }
    }
};
export var addressId2 = {
    parameterPath: [
        "options",
        "addressId"
    ],
    mapper: {
        serializedName: "addressId",
        type: {
            name: "Number"
        }
    }
};
export var addressSearchResultId = {
    parameterPath: "addressSearchResultId",
    mapper: {
        required: true,
        serializedName: "addressSearchResultId",
        type: {
            name: "String"
        }
    }
};
export var all = {
    parameterPath: [
        "options",
        "all"
    ],
    mapper: {
        serializedName: "all",
        type: {
            name: "Boolean"
        }
    }
};
export var applicationKey = {
    parameterPath: "applicationKey",
    mapper: {
        required: true,
        serializedName: "applicationKey",
        type: {
            name: "String"
        }
    }
};
export var approvalStates = {
    parameterPath: [
        "options",
        "approvalStates"
    ],
    mapper: {
        serializedName: "approvalStates",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var area = {
    parameterPath: [
        "options",
        "area"
    ],
    mapper: {
        serializedName: "area",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var areaManager = {
    parameterPath: [
        "options",
        "areaManager"
    ],
    mapper: {
        serializedName: "areaManager",
        type: {
            name: "String"
        }
    }
};
export var articleType = {
    parameterPath: [
        "options",
        "articleType"
    ],
    mapper: {
        serializedName: "articleType",
        type: {
            name: "String"
        }
    }
};
export var atpClusterId0 = {
    parameterPath: "atpClusterId",
    mapper: {
        required: true,
        serializedName: "atpClusterId",
        type: {
            name: "Number"
        }
    }
};
export var atpClusterId1 = {
    parameterPath: [
        "options",
        "atpClusterId"
    ],
    mapper: {
        serializedName: "atpClusterId",
        type: {
            name: "Number"
        }
    }
};
export var bagItemId = {
    parameterPath: "bagItemId",
    mapper: {
        required: true,
        serializedName: "bagItemId",
        type: {
            name: "Number"
        }
    }
};
export var bankAccountId0 = {
    parameterPath: [
        "options",
        "bankAccountId"
    ],
    mapper: {
        serializedName: "bankAccountId",
        type: {
            name: "Number"
        }
    }
};
export var bankAccountId1 = {
    parameterPath: "bankAccountId",
    mapper: {
        required: true,
        serializedName: "bankAccountId",
        type: {
            name: "String"
        }
    }
};
export var bankAccountId2 = {
    parameterPath: "bankAccountId",
    mapper: {
        required: true,
        serializedName: "bankAccountId",
        type: {
            name: "Number"
        }
    }
};
export var bankBranchId = {
    parameterPath: "bankBranchId",
    mapper: {
        required: true,
        serializedName: "bankBranchId",
        type: {
            name: "Number"
        }
    }
};
export var bankBranchIds = {
    parameterPath: [
        "options",
        "bankBranchIds"
    ],
    mapper: {
        serializedName: "bankBranchIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var bankId0 = {
    parameterPath: [
        "options",
        "bankId"
    ],
    mapper: {
        serializedName: "bankId",
        type: {
            name: "Number"
        }
    }
};
export var bankId1 = {
    parameterPath: "bankId",
    mapper: {
        required: true,
        serializedName: "bankId",
        type: {
            name: "Number"
        }
    }
};
export var bankIds = {
    parameterPath: [
        "options",
        "bankIds"
    ],
    mapper: {
        serializedName: "bankIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var bannerIds = {
    parameterPath: [
        "options",
        "bannerIds"
    ],
    mapper: {
        serializedName: "bannerIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var benefitItemCode = {
    parameterPath: [
        "options",
        "benefitItemCode"
    ],
    mapper: {
        serializedName: "benefitItemCode",
        type: {
            name: "String"
        }
    }
};
export var blockingCodeIds = {
    parameterPath: [
        "options",
        "blockingCodeIds"
    ],
    mapper: {
        serializedName: "blockingCodeIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var blockingId = {
    parameterPath: "blockingId",
    mapper: {
        required: true,
        serializedName: "blockingId",
        type: {
            name: "Number"
        }
    }
};
export var blockingState = {
    parameterPath: [
        "options",
        "blockingState"
    ],
    mapper: {
        serializedName: "blockingState",
        type: {
            name: "String"
        }
    }
};
export var blockingType = {
    parameterPath: [
        "options",
        "blockingType"
    ],
    mapper: {
        serializedName: "blockingType",
        type: {
            name: "String"
        }
    }
};
export var branchId = {
    parameterPath: "branchId",
    mapper: {
        required: true,
        serializedName: "branchId",
        type: {
            name: "Number"
        }
    }
};
export var businessToolId = {
    parameterPath: "businessToolId",
    mapper: {
        required: true,
        isConstant: true,
        serializedName: "businessToolId",
        defaultValue: 'VideoShopping',
        type: {
            name: "String"
        }
    }
};
export var campaignId = {
    parameterPath: "campaignId",
    mapper: {
        required: true,
        serializedName: "campaignId",
        type: {
            name: "Number"
        }
    }
};
export var campaignType0 = {
    parameterPath: [
        "options",
        "campaignType"
    ],
    mapper: {
        serializedName: "campaignType",
        type: {
            name: "String"
        }
    }
};
export var campaignType1 = {
    parameterPath: "campaignType",
    mapper: {
        required: true,
        serializedName: "campaignType",
        type: {
            name: "String"
        }
    }
};
export var cardResultType = {
    parameterPath: [
        "options",
        "cardResultType"
    ],
    mapper: {
        serializedName: "cardResultType",
        defaultValue: 'ForPrint',
        type: {
            name: "String"
        }
    }
};
export var catalogueCode = {
    parameterPath: "catalogueCode",
    mapper: {
        required: true,
        serializedName: "catalogueCode",
        type: {
            name: "String"
        }
    }
};
export var catalogueCode1 = {
    parameterPath: "catalogueCode1",
    mapper: {
        required: true,
        serializedName: "catalogueCode",
        type: {
            name: "String"
        }
    }
};
export var catalogueId = {
    parameterPath: "catalogueId",
    mapper: {
        required: true,
        serializedName: "catalogueId",
        type: {
            name: "Number"
        }
    }
};
export var catalogueItemId = {
    parameterPath: "catalogueItemId",
    mapper: {
        required: true,
        serializedName: "catalogueItemId",
        type: {
            name: "String"
        }
    }
};
export var categoryId0 = {
    parameterPath: [
        "options",
        "categoryId"
    ],
    mapper: {
        serializedName: "categoryId",
        type: {
            name: "String"
        }
    }
};
export var categoryId1 = {
    parameterPath: "categoryId",
    mapper: {
        required: true,
        serializedName: "categoryId",
        type: {
            name: "Uuid"
        }
    }
};
export var categoryId2 = {
    parameterPath: "categoryId",
    mapper: {
        required: true,
        serializedName: "categoryId",
        type: {
            name: "String"
        }
    }
};
export var channel = {
    parameterPath: "channel",
    mapper: {
        required: true,
        serializedName: "channel",
        type: {
            name: "String"
        }
    }
};
export var channels = {
    parameterPath: [
        "options",
        "channels"
    ],
    mapper: {
        serializedName: "channels",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var choiceId = {
    parameterPath: "choiceId",
    mapper: {
        required: true,
        serializedName: "choiceId",
        type: {
            name: "Number"
        }
    }
};
export var city = {
    parameterPath: [
        "options",
        "city"
    ],
    mapper: {
        serializedName: "city",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var clubId = {
    parameterPath: "clubId",
    mapper: {
        required: true,
        serializedName: "clubId",
        type: {
            name: "String"
        }
    }
};
export var clubType = {
    parameterPath: "clubType",
    mapper: {
        required: true,
        serializedName: "clubType",
        type: {
            name: "String"
        }
    }
};
export var clubTypes = {
    parameterPath: [
        "options",
        "clubTypes"
    ],
    mapper: {
        serializedName: "clubTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var code = {
    parameterPath: [
        "options",
        "code"
    ],
    mapper: {
        serializedName: "code",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var conceptCode = {
    parameterPath: "conceptCode",
    mapper: {
        required: true,
        serializedName: "conceptCode",
        type: {
            name: "String"
        }
    }
};
export var conceptCodes = {
    parameterPath: "conceptCodes",
    mapper: {
        required: true,
        serializedName: "conceptCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var conceptLabelDomains = {
    parameterPath: [
        "options",
        "conceptLabelDomains"
    ],
    mapper: {
        serializedName: "conceptLabelDomains",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var consultantNumber = {
    parameterPath: "consultantNumber",
    mapper: {
        required: true,
        serializedName: "consultantNumber",
        type: {
            name: "Number"
        }
    }
};
export var consultantNumberPrefix = {
    parameterPath: [
        "options",
        "consultantNumberPrefix"
    ],
    mapper: {
        serializedName: "consultantNumberPrefix",
        type: {
            name: "String"
        }
    }
};
export var contactId = {
    parameterPath: "contactId",
    mapper: {
        required: true,
        serializedName: "contactId",
        type: {
            name: "Number"
        }
    }
};
export var contentId = {
    parameterPath: "contentId",
    mapper: {
        required: true,
        serializedName: "contentId",
        type: {
            name: "String"
        }
    }
};
export var continuationToken = {
    parameterPath: [
        "options",
        "continuationToken"
    ],
    mapper: {
        serializedName: "continuationToken",
        type: {
            name: "String"
        }
    }
};
export var country0 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "country",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var country1 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "country",
        type: {
            name: "String"
        }
    }
};
export var country2 = {
    parameterPath: [
        "options",
        "country"
    ],
    mapper: {
        serializedName: "Country",
        type: {
            name: "String"
        }
    }
};
export var courierId = {
    parameterPath: "courierId",
    mapper: {
        required: true,
        serializedName: "courierId",
        type: {
            name: "String"
        }
    }
};
export var current = {
    parameterPath: [
        "options",
        "current"
    ],
    mapper: {
        serializedName: "current",
        type: {
            name: "Boolean"
        }
    }
};
export var customerAttributeTypeId0 = {
    parameterPath: "customerAttributeTypeId",
    mapper: {
        required: true,
        serializedName: "customerAttributeTypeId",
        type: {
            name: "Number"
        }
    }
};
export var customerAttributeTypeId1 = {
    parameterPath: "customerAttributeTypeId",
    mapper: {
        required: true,
        serializedName: "customerAttributeTypeId",
        type: {
            name: "String"
        }
    }
};
export var customerId0 = {
    parameterPath: "customerId",
    mapper: {
        required: true,
        serializedName: "customerId",
        type: {
            name: "Number"
        }
    }
};
export var customerId1 = {
    parameterPath: [
        "options",
        "customerId"
    ],
    mapper: {
        serializedName: "customerId",
        type: {
            name: "Number"
        }
    }
};
export var customerId2 = {
    parameterPath: "customerId",
    mapper: {
        required: true,
        serializedName: "customerId",
        type: {
            name: "String"
        }
    }
};
export var customerId3 = {
    parameterPath: [
        "options",
        "customerId"
    ],
    mapper: {
        serializedName: "customerId",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var cycleNumber = {
    parameterPath: "cycleNumber",
    mapper: {
        required: true,
        serializedName: "cycleNumber",
        type: {
            name: "Number"
        }
    }
};
export var deliveryAddressId = {
    parameterPath: "deliveryAddressId",
    mapper: {
        required: true,
        serializedName: "deliveryAddressId",
        type: {
            name: "Number"
        }
    }
};
export var deliveryChannelId0 = {
    parameterPath: [
        "options",
        "deliveryChannelId"
    ],
    mapper: {
        serializedName: "deliveryChannelId",
        type: {
            name: "Number"
        }
    }
};
export var deliveryChannelId1 = {
    parameterPath: "deliveryChannelId",
    mapper: {
        required: true,
        serializedName: "deliveryChannelId",
        type: {
            name: "Number"
        }
    }
};
export var deviceToken = {
    parameterPath: "deviceToken",
    mapper: {
        required: true,
        serializedName: "deviceToken",
        type: {
            name: "String"
        }
    }
};
export var district = {
    parameterPath: [
        "options",
        "district"
    ],
    mapper: {
        serializedName: "district",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var documentApprovalId = {
    parameterPath: "documentApprovalId",
    mapper: {
        required: true,
        serializedName: "documentApprovalId",
        type: {
            name: "Number"
        }
    }
};
export var documentId = {
    parameterPath: "documentId",
    mapper: {
        required: true,
        serializedName: "documentId",
        type: {
            name: "Number"
        }
    }
};
export var documentIds = {
    parameterPath: [
        "options",
        "documentIds"
    ],
    mapper: {
        serializedName: "documentIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var documentName = {
    parameterPath: [
        "options",
        "documentName"
    ],
    mapper: {
        serializedName: "documentName",
        type: {
            name: "String"
        }
    }
};
export var documentTypeId = {
    parameterPath: [
        "options",
        "documentTypeId"
    ],
    mapper: {
        serializedName: "documentTypeId",
        type: {
            name: "Number"
        }
    }
};
export var downlineType = {
    parameterPath: [
        "options",
        "downlineType"
    ],
    mapper: {
        serializedName: "downlineType",
        defaultValue: 'PersonalGroup',
        type: {
            name: "String"
        }
    }
};
export var dueDate = {
    parameterPath: [
        "options",
        "dueDate"
    ],
    mapper: {
        serializedName: "dueDate",
        type: {
            name: "DateTime"
        }
    }
};
export var east = {
    parameterPath: [
        "options",
        "east"
    ],
    mapper: {
        serializedName: "east",
        type: {
            name: "Number"
        }
    }
};
export var emailAddress = {
    parameterPath: "emailAddress",
    mapper: {
        required: true,
        serializedName: "emailAddress",
        type: {
            name: "String"
        }
    }
};
export var endConsumerId = {
    parameterPath: "endConsumerId",
    mapper: {
        required: true,
        serializedName: "endConsumerId",
        type: {
            name: "Number"
        }
    }
};
export var endConsumerOrderId = {
    parameterPath: "endConsumerOrderId",
    mapper: {
        required: true,
        serializedName: "endConsumerOrderId",
        type: {
            name: "Number"
        }
    }
};
export var entityId = {
    parameterPath: "entityId",
    mapper: {
        required: true,
        serializedName: "entityId",
        type: {
            name: "String"
        }
    }
};
export var evaluationFilterType0 = {
    parameterPath: [
        "options",
        "evaluationFilterType"
    ],
    mapper: {
        serializedName: "evaluationFilterType",
        defaultValue: 'All',
        type: {
            name: "String"
        }
    }
};
export var evaluationFilterType1 = {
    parameterPath: [
        "options",
        "evaluationFilterType"
    ],
    mapper: {
        serializedName: "evaluationFilterType",
        defaultValue: 'Allowed',
        type: {
            name: "String"
        }
    }
};
export var eWalletAccountId = {
    parameterPath: "eWalletAccountId",
    mapper: {
        required: true,
        serializedName: "eWalletAccountId",
        type: {
            name: "Number"
        }
    }
};
export var excludeChildren = {
    parameterPath: [
        "options",
        "excludeChildren"
    ],
    mapper: {
        serializedName: "excludeChildren",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var excludeWeChatOrders = {
    parameterPath: [
        "options",
        "excludeWeChatOrders"
    ],
    mapper: {
        serializedName: "excludeWeChatOrders",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var externalProvider = {
    parameterPath: "externalProvider",
    mapper: {
        required: true,
        serializedName: "externalProvider",
        type: {
            name: "String"
        }
    }
};
export var featureId = {
    parameterPath: "featureId",
    mapper: {
        required: true,
        serializedName: "featureId",
        type: {
            name: "String"
        }
    }
};
export var file = {
    parameterPath: [
        "options",
        "file"
    ],
    mapper: {
        serializedName: "file",
        type: {
            name: "Stream"
        }
    }
};
export var filter = {
    parameterPath: [
        "options",
        "filter"
    ],
    mapper: {
        serializedName: "filter",
        defaultValue: 'History',
        type: {
            name: "String"
        }
    }
};
export var filterGroup = {
    parameterPath: [
        "options",
        "filterGroup"
    ],
    mapper: {
        serializedName: "filterGroup",
        defaultValue: 'Default',
        type: {
            name: "String"
        }
    }
};
export var filters = {
    parameterPath: [
        "options",
        "filters"
    ],
    mapper: {
        serializedName: "filters",
        type: {
            name: "String"
        }
    }
};
export var folderId = {
    parameterPath: [
        "options",
        "folderId"
    ],
    mapper: {
        serializedName: "folderId",
        type: {
            name: "String"
        }
    }
};
export var folderPath = {
    parameterPath: [
        "options",
        "folderPath"
    ],
    mapper: {
        serializedName: "folderPath",
        type: {
            name: "String"
        }
    }
};
export var frontPageBannerId = {
    parameterPath: "frontPageBannerId",
    mapper: {
        required: true,
        serializedName: "frontPageBannerId",
        type: {
            name: "String"
        }
    }
};
export var height = {
    parameterPath: [
        "options",
        "height"
    ],
    mapper: {
        serializedName: "height",
        type: {
            name: "Number"
        }
    }
};
export var hint = {
    parameterPath: [
        "options",
        "hint"
    ],
    mapper: {
        serializedName: "hint",
        type: {
            name: "String"
        }
    }
};
export var historyType = {
    parameterPath: [
        "options",
        "historyType"
    ],
    mapper: {
        serializedName: "historyType",
        type: {
            name: "String"
        }
    }
};
export var id = {
    parameterPath: "id",
    mapper: {
        required: true,
        serializedName: "id",
        type: {
            name: "String"
        }
    }
};
export var ids = {
    parameterPath: "ids",
    mapper: {
        required: true,
        serializedName: "ids",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var imageInfoId = {
    parameterPath: "imageInfoId",
    mapper: {
        required: true,
        serializedName: "imageInfoId",
        type: {
            name: "Uuid"
        }
    }
};
export var includedProducts = {
    parameterPath: [
        "options",
        "includedProducts"
    ],
    mapper: {
        serializedName: "includedProducts",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var includeTemporary = {
    parameterPath: [
        "options",
        "includeTemporary"
    ],
    mapper: {
        serializedName: "includeTemporary",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var includeTotalCountInResult = {
    parameterPath: [
        "options",
        "includeTotalCountInResult"
    ],
    mapper: {
        serializedName: "includeTotalCountInResult",
        type: {
            name: "Boolean"
        }
    }
};
export var includeUpcoming = {
    parameterPath: [
        "options",
        "includeUpcoming"
    ],
    mapper: {
        serializedName: "includeUpcoming",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var ingredientName = {
    parameterPath: "ingredientName",
    mapper: {
        required: true,
        serializedName: "ingredientName",
        type: {
            name: "String"
        }
    }
};
export var ingredientNames = {
    parameterPath: [
        "options",
        "ingredientNames"
    ],
    mapper: {
        serializedName: "ingredientNames",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var installationId = {
    parameterPath: "installationId",
    mapper: {
        required: true,
        serializedName: "installationId",
        type: {
            name: "String"
        }
    }
};
export var invitationCode = {
    parameterPath: "invitationCode",
    mapper: {
        required: true,
        serializedName: "invitationCode",
        type: {
            name: "String"
        }
    }
};
export var isAutoship = {
    parameterPath: [
        "options",
        "isAutoship"
    ],
    mapper: {
        serializedName: "isAutoship",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var isBlocked = {
    parameterPath: [
        "options",
        "isBlocked"
    ],
    mapper: {
        serializedName: "isBlocked",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var isMember = {
    parameterPath: [
        "options",
        "isMember"
    ],
    mapper: {
        serializedName: "isMember",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var isPurchased = {
    parameterPath: [
        "options",
        "isPurchased"
    ],
    mapper: {
        serializedName: "isPurchased",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var isStandardItem = {
    parameterPath: [
        "options",
        "isStandardItem"
    ],
    mapper: {
        serializedName: "isStandardItem",
        type: {
            name: "Boolean"
        }
    }
};
export var isTemporary = {
    parameterPath: [
        "options",
        "isTemporary"
    ],
    mapper: {
        serializedName: "isTemporary",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var itemCode0 = {
    parameterPath: "itemCode",
    mapper: {
        required: true,
        serializedName: "itemCode",
        type: {
            name: "String"
        }
    }
};
export var itemCode1 = {
    parameterPath: [
        "options",
        "itemCode"
    ],
    mapper: {
        serializedName: "itemCode",
        type: {
            name: "String"
        }
    }
};
export var itemCodes = {
    parameterPath: [
        "options",
        "itemCodes"
    ],
    mapper: {
        serializedName: "itemCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var latitude = {
    parameterPath: [
        "options",
        "latitude"
    ],
    mapper: {
        serializedName: "latitude",
        type: {
            name: "Number"
        }
    }
};
export var locality = {
    parameterPath: [
        "options",
        "locality"
    ],
    mapper: {
        serializedName: "locality",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var loginString = {
    parameterPath: "loginString",
    mapper: {
        required: true,
        serializedName: "loginString",
        type: {
            name: "String"
        }
    }
};
export var longitude = {
    parameterPath: [
        "options",
        "longitude"
    ],
    mapper: {
        serializedName: "longitude",
        type: {
            name: "Number"
        }
    }
};
export var market = {
    parameterPath: [
        "options",
        "market"
    ],
    mapper: {
        serializedName: "market",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var maxResultCount = {
    parameterPath: [
        "options",
        "maxResultCount"
    ],
    mapper: {
        serializedName: "maxResultCount",
        constraints: {
            InclusiveMaximum: 2147483647,
            InclusiveMinimum: 0
        },
        type: {
            name: "Number"
        }
    }
};
export var memberCustomerId = {
    parameterPath: "memberCustomerId",
    mapper: {
        required: true,
        serializedName: "memberCustomerId",
        type: {
            name: "Number"
        }
    }
};
export var messageType = {
    parameterPath: [
        "options",
        "messageType"
    ],
    mapper: {
        serializedName: "messageType",
        type: {
            name: "Number"
        }
    }
};
export var metadata = {
    parameterPath: [
        "options",
        "metadata"
    ],
    mapper: {
        serializedName: "metadata",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var method = {
    parameterPath: [
        "options",
        "method"
    ],
    mapper: {
        serializedName: "method",
        type: {
            name: "String"
        }
    }
};
export var name0 = {
    parameterPath: [
        "options",
        "name"
    ],
    mapper: {
        serializedName: "name",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var name1 = {
    parameterPath: "name",
    mapper: {
        required: true,
        serializedName: "name",
        type: {
            name: "String"
        }
    }
};
export var navigationType = {
    parameterPath: "navigationType",
    mapper: {
        required: true,
        serializedName: "navigationType",
        type: {
            name: "String"
        }
    }
};
export var nodeId0 = {
    parameterPath: "nodeId",
    mapper: {
        required: true,
        serializedName: "nodeId",
        type: {
            name: "String"
        }
    }
};
export var nodeId1 = {
    parameterPath: [
        "options",
        "nodeId"
    ],
    mapper: {
        serializedName: "nodeId",
        type: {
            name: "String"
        }
    }
};
export var north = {
    parameterPath: [
        "options",
        "north"
    ],
    mapper: {
        serializedName: "north",
        type: {
            name: "Number"
        }
    }
};
export var notificationId = {
    parameterPath: "notificationId",
    mapper: {
        required: true,
        serializedName: "notificationId",
        type: {
            name: "String"
        }
    }
};
export var notificationType = {
    parameterPath: [
        "options",
        "notificationType"
    ],
    mapper: {
        serializedName: "notificationType",
        type: {
            name: "String"
        }
    }
};
export var offerId0 = {
    parameterPath: "offerId",
    mapper: {
        required: true,
        serializedName: "offerId",
        type: {
            name: "Number"
        }
    }
};
export var offerId1 = {
    parameterPath: "offerId",
    mapper: {
        required: true,
        serializedName: "offerId",
        type: {
            name: "String"
        }
    }
};
export var offsets = {
    parameterPath: "offsets",
    mapper: {
        required: true,
        serializedName: "offsets",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var onBehalfOfCustomerId = {
    parameterPath: [
        "options",
        "onBehalfOfCustomerId"
    ],
    mapper: {
        serializedName: "onBehalfOfCustomerId",
        type: {
            name: "Number"
        }
    }
};
export var onlinePaymentId = {
    parameterPath: "onlinePaymentId",
    mapper: {
        required: true,
        serializedName: "onlinePaymentId",
        type: {
            name: "Number"
        }
    }
};
export var onlyActive = {
    parameterPath: [
        "options",
        "onlyActive"
    ],
    mapper: {
        serializedName: "onlyActive",
        type: {
            name: "Boolean"
        }
    }
};
export var orderId = {
    parameterPath: "orderId",
    mapper: {
        required: true,
        serializedName: "orderId",
        type: {
            name: "Number"
        }
    }
};
export var orderIds = {
    parameterPath: [
        "options",
        "orderIds"
    ],
    mapper: {
        serializedName: "orderIds",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "Number"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var orderOriginType = {
    parameterPath: [
        "options",
        "orderOriginType"
    ],
    mapper: {
        serializedName: "orderOriginType",
        type: {
            name: "String"
        }
    }
};
export var orderStatus = {
    parameterPath: [
        "options",
        "orderStatus"
    ],
    mapper: {
        serializedName: "orderStatus",
        type: {
            name: "String"
        }
    }
};
export var orderType = {
    parameterPath: [
        "options",
        "orderType"
    ],
    mapper: {
        serializedName: "orderType",
        defaultValue: 'Normal',
        type: {
            name: "String"
        }
    }
};
export var owner = {
    parameterPath: [
        "options",
        "owner"
    ],
    mapper: {
        serializedName: "owner",
        type: {
            name: "String"
        }
    }
};
export var pageIndex = {
    parameterPath: [
        "options",
        "pageIndex"
    ],
    mapper: {
        serializedName: "pageIndex",
        type: {
            name: "Number"
        }
    }
};
export var pathKey = {
    parameterPath: [
        "options",
        "pathKey"
    ],
    mapper: {
        serializedName: "PathKey",
        type: {
            name: "String"
        }
    }
};
export var paymentProviderId = {
    parameterPath: "paymentProviderId",
    mapper: {
        required: true,
        serializedName: "paymentProviderId",
        type: {
            name: "Number"
        }
    }
};
export var pendingRegistrationId = {
    parameterPath: "pendingRegistrationId",
    mapper: {
        required: true,
        serializedName: "pendingRegistrationId",
        type: {
            name: "String"
        }
    }
};
export var periodCode = {
    parameterPath: "periodCode",
    mapper: {
        required: true,
        serializedName: "periodCode",
        type: {
            name: "Number"
        }
    }
};
export var periodId0 = {
    parameterPath: [
        "options",
        "periodId"
    ],
    mapper: {
        serializedName: "periodId",
        type: {
            name: "Number"
        }
    }
};
export var periodId1 = {
    parameterPath: [
        "options",
        "periodId"
    ],
    mapper: {
        serializedName: "periodId",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var potentialQualification = {
    parameterPath: [
        "options",
        "potentialQualification"
    ],
    mapper: {
        serializedName: "potentialQualification",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var product = {
    parameterPath: [
        "options",
        "product"
    ],
    mapper: {
        serializedName: "product",
        type: {
            name: "String"
        }
    }
};
export var productCode = {
    parameterPath: "productCode",
    mapper: {
        required: true,
        serializedName: "productCode",
        type: {
            name: "String"
        }
    }
};
export var productCodes0 = {
    parameterPath: [
        "options",
        "productCodes"
    ],
    mapper: {
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productCodes1 = {
    parameterPath: "productCodes",
    mapper: {
        required: true,
        serializedName: "productCodes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productLabelDomains = {
    parameterPath: [
        "options",
        "productLabelDomains"
    ],
    mapper: {
        serializedName: "productLabelDomains",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var productListId = {
    parameterPath: "productListId",
    mapper: {
        required: true,
        serializedName: "productListId",
        type: {
            name: "String"
        }
    }
};
export var productListingPageId = {
    parameterPath: "productListingPageId",
    mapper: {
        required: true,
        serializedName: "productListingPageId",
        type: {
            name: "String"
        }
    }
};
export var productListType0 = {
    parameterPath: "productListType",
    mapper: {
        required: true,
        serializedName: "productListType",
        type: {
            name: "String"
        }
    }
};
export var productListType1 = {
    parameterPath: "productListType",
    mapper: {
        required: true,
        serializedName: "productListType",
        defaultValue: 'Personal',
        type: {
            name: "String"
        }
    }
};
export var products = {
    parameterPath: [
        "options",
        "products"
    ],
    mapper: {
        serializedName: "products",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var promotionId = {
    parameterPath: "promotionId",
    mapper: {
        required: true,
        serializedName: "promotionId",
        type: {
            name: "Number"
        }
    }
};
export var promotionTypes = {
    parameterPath: [
        "options",
        "promotionTypes"
    ],
    mapper: {
        serializedName: "promotionTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var province = {
    parameterPath: [
        "options",
        "province"
    ],
    mapper: {
        serializedName: "province",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var purchaseItemCode = {
    parameterPath: [
        "options",
        "purchaseItemCode"
    ],
    mapper: {
        serializedName: "purchaseItemCode",
        type: {
            name: "String"
        }
    }
};
export var query = {
    parameterPath: [
        "options",
        "query"
    ],
    mapper: {
        serializedName: "query",
        type: {
            name: "String"
        }
    }
};
export var radius = {
    parameterPath: [
        "options",
        "radius"
    ],
    mapper: {
        serializedName: "radius",
        type: {
            name: "Number"
        }
    }
};
export var recurringPaymentCardId = {
    parameterPath: "recurringPaymentCardId",
    mapper: {
        required: true,
        serializedName: "recurringPaymentCardId",
        type: {
            name: "Number"
        }
    }
};
export var region = {
    parameterPath: [
        "options",
        "region"
    ],
    mapper: {
        serializedName: "region",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var registrationId = {
    parameterPath: "registrationId",
    mapper: {
        required: true,
        serializedName: "registrationId",
        type: {
            name: "String"
        }
    }
};
export var relatedArticlesUrls = {
    parameterPath: [
        "options",
        "relatedArticlesUrls"
    ],
    mapper: {
        serializedName: "relatedArticlesUrls",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var relationTypes = {
    parameterPath: [
        "options",
        "relationTypes"
    ],
    mapper: {
        serializedName: "relationTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var rootLevelOnly = {
    parameterPath: [
        "options",
        "rootLevelOnly"
    ],
    mapper: {
        serializedName: "rootLevelOnly",
        defaultValue: true,
        type: {
            name: "Boolean"
        }
    }
};
export var search = {
    parameterPath: [
        "options",
        "search"
    ],
    mapper: {
        serializedName: "search",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var searchPhrase = {
    parameterPath: [
        "options",
        "searchPhrase"
    ],
    mapper: {
        serializedName: "searchPhrase",
        type: {
            name: "String"
        }
    }
};
export var searchTerm = {
    parameterPath: [
        "options",
        "searchTerm"
    ],
    mapper: {
        serializedName: "searchTerm",
        type: {
            name: "String"
        }
    }
};
export var searchText = {
    parameterPath: [
        "options",
        "searchText"
    ],
    mapper: {
        serializedName: "SearchText",
        type: {
            name: "String"
        }
    }
};
export var sectionId = {
    parameterPath: "sectionId",
    mapper: {
        required: true,
        serializedName: "sectionId",
        type: {
            name: "Number"
        }
    }
};
export var sessionId = {
    parameterPath: "sessionId",
    mapper: {
        required: true,
        serializedName: "sessionId",
        type: {
            name: "String"
        }
    }
};
export var settingId = {
    parameterPath: "settingId",
    mapper: {
        required: true,
        serializedName: "settingId",
        type: {
            name: "String"
        }
    }
};
export var settingsClient = {
    parameterPath: "settingsClient",
    mapper: {
        required: true,
        serializedName: "settingsClient",
        type: {
            name: "String"
        }
    }
};
export var shortUrls = {
    parameterPath: [
        "options",
        "shortUrls"
    ],
    mapper: {
        serializedName: "shortUrls",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var showTypes = {
    parameterPath: [
        "options",
        "showTypes"
    ],
    mapper: {
        serializedName: "showTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var since = {
    parameterPath: [
        "options",
        "since"
    ],
    mapper: {
        serializedName: "since",
        type: {
            name: "DateTime"
        }
    }
};
export var skip0 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        type: {
            name: "Number"
        }
    }
};
export var skip1 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "skip",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var skip2 = {
    parameterPath: [
        "options",
        "skip"
    ],
    mapper: {
        serializedName: "Skip",
        type: {
            name: "Number"
        }
    }
};
export var skipCount = {
    parameterPath: [
        "options",
        "skipCount"
    ],
    mapper: {
        serializedName: "skipCount",
        constraints: {
            InclusiveMaximum: 2147483647,
            InclusiveMinimum: 0
        },
        type: {
            name: "Number"
        }
    }
};
export var sort = {
    parameterPath: [
        "options",
        "sort"
    ],
    mapper: {
        serializedName: "sort",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var sortBy = {
    parameterPath: [
        "options",
        "sortBy"
    ],
    mapper: {
        serializedName: "sortBy",
        defaultValue: 'Visit',
        type: {
            name: "String"
        }
    }
};
export var sorting = {
    parameterPath: [
        "options",
        "sorting"
    ],
    mapper: {
        serializedName: "sorting",
        type: {
            name: "String"
        }
    }
};
export var sortType = {
    parameterPath: [
        "options",
        "sortType"
    ],
    mapper: {
        serializedName: "sortType",
        defaultValue: 'Ascending',
        type: {
            name: "String"
        }
    }
};
export var south = {
    parameterPath: [
        "options",
        "south"
    ],
    mapper: {
        serializedName: "south",
        type: {
            name: "Number"
        }
    }
};
export var status = {
    parameterPath: [
        "options",
        "status"
    ],
    mapper: {
        serializedName: "status",
        type: {
            name: "String"
        }
    }
};
export var statusTypes = {
    parameterPath: [
        "options",
        "statusTypes"
    ],
    mapper: {
        serializedName: "statusTypes",
        type: {
            name: "Sequence",
            element: {
                type: {
                    name: "String"
                }
            }
        }
    },
    collectionFormat: msRest.QueryCollectionFormat.Multi
};
export var step = {
    parameterPath: "step",
    mapper: {
        required: true,
        serializedName: "step",
        type: {
            name: "Number"
        }
    }
};
export var stepNumber = {
    parameterPath: "stepNumber",
    mapper: {
        required: true,
        serializedName: "stepNumber",
        type: {
            name: "Number"
        }
    }
};
export var storename = {
    parameterPath: [
        "options",
        "storename"
    ],
    mapper: {
        serializedName: "storename",
        type: {
            name: "String"
        }
    }
};
export var street = {
    parameterPath: [
        "options",
        "street"
    ],
    mapper: {
        serializedName: "street",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var subscriptionId = {
    parameterPath: "subscriptionId",
    mapper: {
        required: true,
        serializedName: "subscriptionId",
        type: {
            name: "Number"
        }
    }
};
export var subscriptionItemId = {
    parameterPath: "subscriptionItemId",
    mapper: {
        required: true,
        serializedName: "subscriptionItemId",
        type: {
            name: "Number"
        }
    }
};
export var take0 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        type: {
            name: "Number"
        }
    }
};
export var take1 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 50,
        type: {
            name: "Number"
        }
    }
};
export var take2 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 100,
        type: {
            name: "Number"
        }
    }
};
export var take3 = {
    parameterPath: [
        "options",
        "take"
    ],
    mapper: {
        serializedName: "take",
        defaultValue: 12,
        type: {
            name: "Number"
        }
    }
};
export var taskId = {
    parameterPath: "taskId",
    mapper: {
        required: true,
        serializedName: "taskId",
        type: {
            name: "String"
        }
    }
};
export var telephoneId0 = {
    parameterPath: "telephoneId",
    mapper: {
        required: true,
        serializedName: "telephoneId",
        type: {
            name: "String"
        }
    }
};
export var telephoneId1 = {
    parameterPath: "telephoneId",
    mapper: {
        required: true,
        serializedName: "telephoneId",
        type: {
            name: "Number"
        }
    }
};
export var termId = {
    parameterPath: "termId",
    mapper: {
        required: true,
        serializedName: "termId",
        type: {
            name: "String"
        }
    }
};
export var termsCustomerType = {
    parameterPath: [
        "options",
        "termsCustomerType"
    ],
    mapper: {
        serializedName: "termsCustomerType",
        defaultValue: 'Consultant',
        type: {
            name: "String"
        }
    }
};
export var termsType = {
    parameterPath: [
        "options",
        "termsType"
    ],
    mapper: {
        serializedName: "termsType",
        type: {
            name: "String"
        }
    }
};
export var thumbnailQuality = {
    parameterPath: [
        "options",
        "thumbnailQuality"
    ],
    mapper: {
        serializedName: "thumbnailQuality",
        defaultValue: 90,
        type: {
            name: "Number"
        }
    }
};
export var thumbnailSize = {
    parameterPath: [
        "options",
        "thumbnailSize"
    ],
    mapper: {
        serializedName: "thumbnailSize",
        defaultValue: 1080,
        type: {
            name: "Number"
        }
    }
};
export var top0 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 5,
        type: {
            name: "Number"
        }
    }
};
export var top1 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 10,
        type: {
            name: "Number"
        }
    }
};
export var top2 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 1,
        type: {
            name: "Number"
        }
    }
};
export var top3 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        type: {
            name: "Number"
        }
    }
};
export var top4 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "Top",
        type: {
            name: "Number"
        }
    }
};
export var top5 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 12,
        type: {
            name: "Number"
        }
    }
};
export var top6 = {
    parameterPath: [
        "options",
        "top"
    ],
    mapper: {
        serializedName: "top",
        defaultValue: 0,
        type: {
            name: "Number"
        }
    }
};
export var type0 = {
    parameterPath: "type",
    mapper: {
        required: true,
        serializedName: "type",
        type: {
            name: "String"
        }
    }
};
export var type1 = {
    parameterPath: [
        "options",
        "type"
    ],
    mapper: {
        serializedName: "type",
        defaultValue: 'Closing',
        type: {
            name: "String"
        }
    }
};
export var type2 = {
    parameterPath: [
        "options",
        "type"
    ],
    mapper: {
        serializedName: "type",
        type: {
            name: "String"
        }
    }
};
export var typeCode = {
    parameterPath: [
        "options",
        "typeCode"
    ],
    mapper: {
        serializedName: "typeCode",
        type: {
            name: "String"
        }
    }
};
export var unionId = {
    parameterPath: "unionId",
    mapper: {
        required: true,
        serializedName: "unionId",
        type: {
            name: "String"
        }
    }
};
export var userHash = {
    parameterPath: [
        "options",
        "userHash"
    ],
    mapper: {
        serializedName: "userHash",
        type: {
            name: "String"
        }
    }
};
export var validityDate = {
    parameterPath: [
        "options",
        "validityDate"
    ],
    mapper: {
        serializedName: "validityDate",
        type: {
            name: "DateTime"
        }
    }
};
export var voucherCode = {
    parameterPath: "voucherCode",
    mapper: {
        required: true,
        serializedName: "voucherCode",
        type: {
            name: "String"
        }
    }
};
export var wayBillNumber = {
    parameterPath: "wayBillNumber",
    mapper: {
        required: true,
        serializedName: "wayBillNumber",
        type: {
            name: "String"
        }
    }
};
export var west = {
    parameterPath: [
        "options",
        "west"
    ],
    mapper: {
        serializedName: "west",
        type: {
            name: "Number"
        }
    }
};
export var width = {
    parameterPath: [
        "options",
        "width"
    ],
    mapper: {
        serializedName: "width",
        type: {
            name: "Number"
        }
    }
};
export var xAddressFormContext = {
    parameterPath: [
        "options",
        "xAddressFormContext"
    ],
    mapper: {
        serializedName: "x-address-form-context",
        type: {
            name: "String"
        }
    }
};
export var xClientApplication = {
    parameterPath: "xClientApplication",
    mapper: {
        required: true,
        serializedName: "x-client-application",
        type: {
            name: "String"
        }
    }
};
export var xClientPlatform = {
    parameterPath: [
        "options",
        "xClientPlatform"
    ],
    mapper: {
        serializedName: "x-client-platform",
        type: {
            name: "String"
        }
    }
};
export var xDownlinePermission = {
    parameterPath: [
        "options",
        "xDownlinePermission"
    ],
    mapper: {
        serializedName: "x-downline-permission",
        defaultValue: 'Profile',
        type: {
            name: "String"
        }
    }
};
export var xMockResponse = {
    parameterPath: [
        "options",
        "xMockResponse"
    ],
    mapper: {
        serializedName: "x-mock-response",
        defaultValue: false,
        type: {
            name: "Boolean"
        }
    }
};
export var xNotificationCentreApiKey = {
    parameterPath: [
        "options",
        "xNotificationCentreApiKey"
    ],
    mapper: {
        serializedName: "X-NotificationCentre-ApiKey",
        type: {
            name: "String"
        }
    }
};
export var xPaymentApiVersion = {
    parameterPath: [
        "options",
        "xPaymentApiVersion"
    ],
    mapper: {
        serializedName: "x-payment-api-version",
        type: {
            name: "String"
        }
    }
};
export var xPaymentChannel = {
    parameterPath: [
        "options",
        "xPaymentChannel"
    ],
    mapper: {
        serializedName: "x-payment-channel",
        type: {
            name: "String"
        }
    }
};
export var xPaymentShopperLocale = {
    parameterPath: [
        "options",
        "xPaymentShopperLocale"
    ],
    mapper: {
        serializedName: "x-payment-shopper-locale",
        type: {
            name: "String"
        }
    }
};
export var xPlacement = {
    parameterPath: [
        "options",
        "xPlacement"
    ],
    mapper: {
        serializedName: "x-placement",
        type: {
            name: "String"
        }
    }
};
export var xProcessContext0 = {
    parameterPath: [
        "options",
        "xProcessContext"
    ],
    mapper: {
        serializedName: "x-process-context",
        defaultValue: 'Profile',
        type: {
            name: "String"
        }
    }
};
export var xProcessContext1 = {
    parameterPath: [
        "options",
        "xProcessContext"
    ],
    mapper: {
        serializedName: "x-process-context",
        defaultValue: 'Checkout',
        type: {
            name: "String"
        }
    }
};
export var xReferer = {
    parameterPath: [
        "options",
        "xReferer"
    ],
    mapper: {
        serializedName: "x-referer",
        type: {
            name: "String"
        }
    }
};
export var xTenantContext = {
    parameterPath: "xTenantContext",
    mapper: {
        required: true,
        serializedName: "x-tenant-context",
        type: {
            name: "String"
        }
    }
};
export var zipCode = {
    parameterPath: [
        "options",
        "zipCode"
    ],
    mapper: {
        serializedName: "zipCode",
        defaultValue: '',
        type: {
            name: "String"
        }
    }
};
export var zoom = {
    parameterPath: [
        "options",
        "zoom"
    ],
    mapper: {
        serializedName: "zoom",
        type: {
            name: "Number"
        }
    }
};

//# sourceMappingURL=parameters.js.map
